import React from "react";
import styles from "./MediaDevices.module.css";

// TODO: bring more device mgmt functionality here
export default function (props: any) {
    const { children, ...restProps } = props;
    return (
        <div className={styles.mediaDevices} {...restProps}>
            {props.children}
        </div>
    );
}
